import React from 'react';
import { Modal } from 'snacks-design-system';
import PIEModalHeader from '../PIEModalHeader';
import PIEModalBanner from '../PIEModalBanner';
import PIEModalContent from '../PIEModalContent';
import PIEModalFooter from '../PIEModalFooter';
import PIEModalScrollContent from '../PIEModalScrollContent';
interface componentProps {
  children: React.ReactNode;
  className?: string;
  isOpen: boolean;
  priority?: 'low' | 'regular' | 'high';
  size?: 'small' | 'medium' | 'large';
  modPositionCenter?: boolean;
  modSSR?: boolean;
  modOverlay?: boolean;
  modSticky?: boolean;
  modCenterContent?: boolean;
  contentLabel?: string;
  modReturnFocusAfterClose?: boolean;
  modCloseOnOverlayClick?: boolean;
  appElementSelector?: string;
  onClose?: () => void;
  onOpenStateChange?: () => void;
  onAfterClose?: () => void;
  dataSctrack?: string;
  qaSelector?: string;
}

const PIEModal = (props: componentProps) => {
  return <Modal {...props} />;
};

PIEModal.Header = PIEModalHeader;
PIEModal.Banner = PIEModalBanner;
PIEModal.Content = PIEModalContent;
PIEModal.Footer = PIEModalFooter;
PIEModal.ScrollContent = PIEModalScrollContent;
export default PIEModal;
